
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { Toast } from 'vant';
import { TbRole } from '@/http';
@Component({
    components: {
      
    },
})
export default class addRolePanel extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    name="";

    isLoading=false;
  

    created() {
    }
    mounted() {
     
        
    }

    cancelFun(){
        this.resetForm();
        this.$emit('cancelFun');
    }
    resetForm(){
        this.name = "";
    }
    async saveFun(){
        if(!this.name){
            Toast('请输入角色名称');
            return;
        }
        if(this.isLoading)return;
        this.isLoading = true;
        try {
            let res =await TbRole.PostTbRole({
                name:this.name
            })
            this.isLoading = false;
            Toast("新增成功");
            this.$emit('confirmAdd')
            this.cancelFun();
        } catch (error) {
            this.isLoading = false;
        }   
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/staff/components/addRolePanel.vue